import {
  AuthContainer,
  AuthContainerChild,
} from "../../components/auth/styles";
import { Trans } from "react-i18next";
import RecoverPassword from "../../components/RecoverPassword/RecoverPassword";

export const RecoverPasswordPage = () => {
  return (
    <AuthContainer>
      <AuthContainerChild>
        <h1>
          <Trans i18nKey="RecoverPasswordPage" />
        </h1>
        <RecoverPassword />
      </AuthContainerChild>
    </AuthContainer>
  );
};
